// extracted by mini-css-extract-plugin
module.exports = {"LoadingPage":"Loading_LoadingPage__28K3e","Content":"Loading_Content__kOTLC","Logo":"Loading_Logo__3XYOx","pulse":"Loading_pulse__22AWb","Title":"Loading_Title__2zhEl"};